export const xmlStr = `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" id="Definitions_0awvi28" targetNamespace="http://bpmn.io/schema/bpmn" xmlns:modeler="http://camunda.org/schema/modeler/1.0" exporter="Camunda Modeler" exporterVersion="5.4.2" modeler:executionPlatform="Camunda Platform" modeler:executionPlatformVersion="7.18.0">
  <bpmn:process id="Process_0bm8wsr" isExecutable="true">
    <bpmn:startEvent id="StartEvent_1" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_0bm8wsr">
      <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1">
        <dc:Bounds x="179" y="159" width="36" height="36" />
      </bpmndi:BPMNShape>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`;

// 表单类型
export const FORM_TYPE = [
  {
    label: "系统表单",
    value: "1",
  },
  {
    label: "创建表单",
    value: "2",
  },
];

// 表单状态
export const FORM_STATUS = [
  {
    label: "启用",
    value: "1",
  },
  {
    label: "停用",
    value: "0",
  },
];

// 流程部署状态
export const PROCESS_DEPLOY_STATUS = [
  {
    label: "未部署",
    value: "act_model_status_001",
  },
  {
    label: "已修改未重新部署",
    value: "act_model_status_002",
  },
  {
    label: "已部署",
    value: "act_model_status_003",
  },
];

// 流程完成状态
export const PROCESS_COMPLETE_TYPE = [
  {
    label: "已完成",
    value: "act_complete_type_001",
  },
  {
    label: "未完成",
    value: "act_complete_type_002",
  },
];

// 流程状态对象
export const PROCESS_COMPLETE_TYPE_OBJECT = {
  act_complete_type_001: "已完成",
  act_complete_type_002: "未完成",
};

// 流程提交类型
export const PROCESS_SUBMIT_TYPE_ARRAY = [
  {
    label: "提交",
    value: "act_submit_type_001",
  },
  {
    label: "取消",
    value: "act_submit_type_002",
  },
  {
    label: "驳回",
    value: "act_submit_type_003",
  },
  {
    label: "驳回到指定节点",
    value: "act_submit_type_004",
  },
  {
    label: "驳回到上级",
    value: "act_submit_type_005",
  },
  {
    label: "批准",
    value: "act_submit_type_006",
  },
];

export const PROCESS_SUBMIT_TYPE_OBJECT = {
  act_submit_type_001: "提交",
  act_submit_type_002: "取消",
  act_submit_type_003: "驳回",
  act_submit_type_004: "驳回到指定节点",
  act_submit_type_005: "驳回到上级",
  act_submit_type_006: "批准",
};
